import React, { useState, useEffect } from "react";
import {
  StepperContainer,
  CirclesRow,
  LabelsRow,
  StepCircle,
  StepLine,
  StepLabel, StepIconCheck
} from "./localStyle";
import { getLocalStorage } from "global/utils/safeJsonParse";
import { LoadingLogoWrapperStepper, RotatingArcStepper, CenterLogoStepper } from "../../../../../_+_Portal/components/Genericos/Loading/localstyle";
import Llama from "../../../../../_+_Portal/components/Genericos/Loading/assets/Llama.png";
import ObjNaranja from "../../../../../_+_Portal/components/Genericos/Loading/assets/ObjNaranja.png";

const PASOS_VERIFICACION = [
  "Orden recibida",
  "En revisión",
  "Verificando datos",
];

const INTERVALO_MS = 3000;
const idTerminal = getLocalStorage("idTerminal");

const StepperAnimado = () => {
  const [pasoActivo, setPasoActivo] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setPasoActivo((prev) => {
        if (prev >= PASOS_VERIFICACION.length - 1) {
          clearInterval(timer);
          return prev;
        }
        return prev + 1;
      });
    }, INTERVALO_MS);
    return () => clearInterval(timer);
  }, []);

  return (
    <StepperContainer $isTerminal={idTerminal}>
      <CirclesRow>
        {PASOS_VERIFICACION.map((_, index) => (
          <React.Fragment key={index}>
            {index > 0 && <StepLine $completado={index <= pasoActivo} />}
            <StepCircle
              $completado={index < pasoActivo}
              $activo={index === pasoActivo}
            >
              {index < pasoActivo && <StepIconCheck>✓</StepIconCheck>}
              {index === pasoActivo && <AnimatedDots />}
              {index > pasoActivo && index + 1}
            </StepCircle>
          </React.Fragment>
        ))}
      </CirclesRow>
      <LabelsRow>
        {PASOS_VERIFICACION.map((paso, index) => (
          <StepLabel
            key={index}
            $completado={index < pasoActivo}
            $activo={index === pasoActivo}
          >
            {paso}
          </StepLabel>
        ))}
      </LabelsRow>
    </StepperContainer>
  );
};

const AnimatedDots = () => {
  return <LoadingLogoWrapperStepper>
    <RotatingArcStepper>
      <img src={ObjNaranja} alt="" />
    </RotatingArcStepper>
    <CenterLogoStepper src={Llama} alt="Logo" />
  </LoadingLogoWrapperStepper>;
};

export default StepperAnimado;
